<template>
  <div class="page page__list">
    <div class="nav">
      <span :class="selected1 == '拆解日报分析' ? 'selected1' : ''" @click="selected1 = '拆解日报分析'">拆解日报分析</span>
      <span>|</span>
      <span :class="selected1 == '拆解日报表' ? 'selected1' : ''" @click="selected1 = '拆解日报表'">拆解日报表</span>
    </div>

    <analysis v-if="selected1 == '拆解日报分析'"></analysis>

    <detail v-if="selected1 == '拆解日报表'"></detail>

  </div>
</template>

<script>
import Analysis from "@/components/DisassembleHourReport/Analysis.vue";
import Detail from "@/components/DisassembleHourReport/Detail.vue";

export default {
  components: {
    Analysis,
    Detail
  },
  data() {
    return {
      selected1: '拆解日报分析'
    };
  }
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559F;
}
@media screen and (min-width: 500px) {
  .nav{
    display: none
  }
}
</style>